import { useState } from 'react';
import { Toaster } from 'react-hot-toast';
import { useRecoilValue } from 'recoil';

import { userAtom } from '../../../services/atoms/auth.atoms';
import { TopInfo } from "../../components/top-info/top-info";
import ChangePassForm from "./components/change-pass-form";
import PersonalInfoForm from "./components/personal-info-form";
import RecoverPassModal from "./components/recover-pass-modal";

const topInfo = { title: 'Mi Perfil', subtitle: 'Información personal' };

const Profile = () => {
  const [open, setOpen] = useState(false);
  const userData = useRecoilValue(userAtom);
  const handleOpen = () => setOpen(!open);
  return (
    <div className="gm-module-screen-container">
      <Toaster />
      <RecoverPassModal toggle={handleOpen} open={open} />
      <TopInfo info={topInfo} />
      <div className="gm-module-container">
        <div className="gm-profile-title">Mi Cuenta</div>
        <div className="gm-profile-data-container">
          <div className="gm-profile-image-container">
            <div className="gm-profile-image">{userData.data.displayName.split(" ").map((n) => n[0])}</div>
            {/* <button className="gm-outline-button" type="button">Cambiar Imagen</button> */}
          </div>
          <div>
            <PersonalInfoForm/>
            <ChangePassForm handleOpen={handleOpen} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Profile;